import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectError, setShowError } from '../../core/store/error';
import { Alert as AlertUI } from '@applyft-web/ui-components';

export const Alert = () => {
  const { t } = useTranslation();
  const { show, message } = useSelector(selectError);
  const dispatch = useDispatch();

  const clearError = useCallback(() => dispatch(setShowError(false)), [dispatch]);

  const doesEmailExist = ['the email has already been taken', 'userEmailTaken'].includes(
    message.replace('.', '').trim().toLowerCase(),
  );

  return (
    <AlertUI
      show={show}
      message={doesEmailExist ? t('email_exist') : message}
      clearError={clearError}
      customStyles={'z-index: 1000;'} // TODO: remove after library update
    />
  );
};
